// ToDo: We are not using this page, should be removed
import { mapActions, mapState } from 'vuex';
import * as cookies from '@/utils/cookies';
import { login as loginMessage } from '@/config/auth-messages.json';

export default {
  methods: {
    ...mapActions({
      openNotification: 'openNotification',
      closeNotification: 'closeNotification',
      clearAuthToken: 'clearAuthToken',
      clearAuthTokenId: 'clearAuthTokenId',
      clearFiduciary: 'clearFiduciary',
      logError: 'logError',
    }),
    signout() {
      if (this.tokenId()) {
        const url = `${process.env.VUE_APP_ACTUAL_API_URL}/users/logout`;
        this.$request
          .fetch(url, {
            method: 'post',
            body: JSON.stringify({}),
            headers: {
              'ms-sso': this.tokenId(),
            },
          })
          .then((response) => response && response.json())
          .catch((error) => {
            this.logError({
              errorFrom: 'AuthMixin:methods:signout',
              details: {
                ...error,
                message: error.message,
              },
            });
          })
          .finally(() => {
            this.cleanAndExit();
          });
      } else {
        this.cleanAndExit();
      }
    },
    cleanAndExit() {
      this.clearAuthToken();
      this.clearFiduciary();
      // Load default config
      this.$store.dispatch('setConfig', '');
      this.$store.reset();
      this.$router.push('/login').catch((error) => {
        this.logError({
          errorFrom: 'AuthMixin:methods:cleanAndExit',
          details: {
            message: error.message,
          },
        });
      });
    },
    async cleanAuthTokenIdAndStoreAndThenExit() {
      this.clearAuthTokenId();
      this.clearFiduciary();
      // Load default config
      await this.$store.dispatch('setConfig', '');
      this.$store.reset();
    },
    tokenId() {
      const cookie = cookies.getCookie('ms-sso');
      if (cookie.value) {
        return cookie.value;
      }
      return null;
    },
  },
  computed: {
    ...mapState({
      hasTokenId: (state) => state.user.auth.tokenId,
    }),
  },
  watch: {
    errorType(newValue) {
      if (!newValue) {
        return null;
      }

      let notificationConfig = null;
      if (newValue === 'invalid-credentials') {
        notificationConfig = {
          notificationType: 'error',
          title: 'Invalid Credentials',
          message: loginMessage.error.invalidCredentials,
        };
      } else if (newValue === 'missing-credentials') {
        notificationConfig = {
          notificationType: 'error',
          title: 'Missing Credentials',
          message: loginMessage.error.missingCredentials,
        };
      } else if (newValue === 'recaptcha-validation-error') {
        notificationConfig = {
          notificationType: 'error',
          title: 'reCpactha Validation Error',
          message: loginMessage.error.reCapcthaValidationError,
        };
      }
      this.openNotification(notificationConfig);
      return notificationConfig;
    },
  },
};
